import { mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';
import billService from './../../services/bill';

export default {
  data() {
    return {
      form: new Forms({
        reminderType: {
          value: '',
          type: 'select',
        },
        penaltyFee: {
          value: '',
          type: 'select',
        },
        feeAmount: {
          value: '',
          type: 'text',
        },
        notes: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: false,
    };
  },

  computed: {
    billingNumber() {
      return `#${this.bill.billingNumber}`;
    },
    penaltyFees() {
      return this.bill.penaltyFees;
    },
    canCreateWithFee() {
      return this.bill.canCreateReminderWithFee;
    },
    disableSaveButton() {
      return this.form.reminderType === '' || (!this.form.isHidden('penaltyFee') && this.form.penaltyFee === '');
    },
    currency() {
      return this.bill.currency ? this.bill.currency.code : '';
    },
    reminderWarning() {
      return this.bill.reminderWithFeeWarning ? this.bill.reminderWithFeeWarning : [];
    },
  },

  watch: {
    'form.reminderType': function (value) {
      this.form.showField('penaltyFee');
      this.form.showField('feeAmount');
      if (value === 'withFees') {
        if (this.penaltyFees.length > 0) {
          this.form.hideField('feeAmount');
          this.form.setOptions('penaltyFee', this.penaltyFees.map(item => ({
            id: item.id,
            name: `${item.fee_rate} ${item.type === 'fixed' ? this.currency : '%'}`,
          })));
        } else {
          this.form.hideField('penaltyFee');
        }
      } else {
        this.form.hideField('penaltyFee');
        this.form.hideField('feeAmount');
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    save() {
      this.form.loading = true;
      billService.createReminder(this.bill.id, this.form.data())
      .then(() => {
        this.onComplete();
        this.closeModal();
        this.$message({
          showClose: true,
          message: 'Successful',
          customClass: 'success',
        });
        this.form.loading = false;
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    show() {
      this.loading = true;
      this.form.hideField('penaltyFee');
      this.form.hideField('feeAmount');

      const reminderOptions = [
        { id: 'noFees', name: this.$t('form.billReminderModal.penaltyFee.options.withoutFees') },
      ];
      if (this.canCreateWithFee) {
        reminderOptions.push({ id: 'withFees', name: this.$t('form.billReminderModal.penaltyFee.options.withFees') });
      }
      this.form.setOptions('reminderType', reminderOptions);
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
      this.onClose();
    },
  },

  mounted() {
    this.show();
  },

  props: {
    bill: {
      type: Object,
      required: true,
    },
    onComplete: {
      type: Function,
      required: false,
    },
    onClose: {
      type: Function,
      required: false,
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/billReminderModal/billReminderModal.js